import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import {SkipNext} from "@mui/icons-material";

export default function ({onSkip, skipMessage = "Faire un devis papier"}) {
    return (
        <>
            <Typography variant="h6">
                Étape 1. Consulter le document
            </Typography>
            <Typography>
                Le sociétaire clique sur le bouton "Voir le document" et le consulte, si le document ne s'affiche pas,
                il peut le recevoir par mail en cliquant sur le bouton "Le recevoir par mail".
            </Typography>

            <Typography variant="h6" mt={3}>
                Étape 2. Renseigner un champ de sécurité
            </Typography>
            <Typography>
                Le sociétaire sélectionne le champ de sécurité "Date de naissance" et le complète.
            </Typography>

            <Typography variant="h6" mt={3}>
                Étape 3. Signer avec le doigt
            </Typography>
            <Typography>
                Le sociétaire signe avec son doigt dans le cadre. Puis il clique sur "Valider".
            </Typography>

            <Box mt={10} display={"flex"} justifyContent="center">
                <Button
                    startIcon={<SkipNext/>}
                    variant="contained"
                    color={"warning"}
                    sx={{width: "80%"}}
                    onClick={onSkip}
                    data-test="insurance-button-skip-signature"
                >
                    {skipMessage}
                </Button>
            </Box>
        </>
    )
}
